export default __webpack_public_path__ + "static/success-red-2e084b764754db3a2eaf4379cfca3d1a.png";